import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-manage-allocations',
    templateUrl: './manage-allocations.component.html',
    styleUrls: ['./manage-allocations.component.scss']
})
export class ManageAllocationsComponent implements OnInit {

    @Input() beneficiaryData: UntypedFormGroup;
    @Input() contentData;

    constructor() { }

    ngOnInit() { }

    get Beneficiary(): FormArray {
        return this.beneficiaryData.get('beneficiary') as FormArray
    }

    getTotal(): number {

        let total = 0;
        this.Beneficiary.controls.forEach(ben => {
            total += +ben.get('beneficiaryAllocPercentage')?.value || 0
        })

        total = Number(total.toFixed(2));
        return total
    }

}